import { ErrorBoundary } from 'react-error-boundary';
import { captureException } from '@sentry/react-router';

import { IconListSection as IconListSectionModule, type IconListSectionProps } from '@cx-modules/icon-list-section';

export const IconListSection = (props: IconListSectionProps) => (
  <ErrorBoundary
    fallbackRender={({ error }) => {
      captureException(error);
      return null;
    }}
  >
    <IconListSectionModule {...props} />
  </ErrorBoundary>
);
